import React, { useState, useEffect } from "react";
import { data, useNavigate } from "react-router-dom";

import FilterListIcon from "@mui/icons-material/FilterList";

import moment from "moment";
import { enqueueSnackbar } from "notistack";
import CustomDrawer from "../../components/customComponents/drawer/CustomDrawer";
import CustomConfirmation from "../../components/customComponents/confirmation/CustomConfirmation";
import FilterDRawerCases from "./FilterCase";
import CustomMUITable from "../../components/customComponents/table/CustomMuiTable";
import { Button, CircularProgress } from "@mui/material";
import ChangeCaseAdvisor from "./ChangeCaseAdvisor";
import DownloadIcon from "@mui/icons-material/Download";

import ChangeCaseStatus from "./ChangeCaseStatus";
import {
  delete_Case_api,
  get_advisor_list_with_filters,
  get_cases_api,
  get_cases_Detail_api,
} from "../../DAL/adminAuth/auth";
import { show_proper_words } from "../../utils/constant";
import { makeStyles } from "@mui/styles";

const Cases = () => {
  const useStyles = makeStyles(() => ({
    loading: {
      marginLeft: "50%",
      marginTop: "20%",
    },
  }));

  const INITIAL_VALUES = {
    selectedRow: null,
    loading: true,
    confirmDeleteOpenMember: false,
    drawerOpen: false,
    selectedCategory: null,
    members: [],
  };

  const [memberState, setMemberState] = useState(INITIAL_VALUES);
  const [caseSStatusDATA, setCaseStatusData] = useState("");
  const [selectedAdvisor, setSelectedAdvisor] = useState(null); // Changed to null for Autocomplete
  const [newpage, setPageTitle] = useState(null);
  console.log(newpage, "pageTitlepageTitlepageTitle");
  const classes = useStyles();

  const new_valyues = {
    deleteRecordingId: null,
    deleteDialogOpen: false,
    drawerOpen: false,
    selectedCategory: null,
    change_advisor_status_drawer: false,
    select_change_drawer_advisor: null,
    change_case_status_drawer: false,
    select_change_drawer_case: null,
    image: "",
  };

  const handleopenFilterDrawer = () => {
    setRecordingListState((old) => ({
      ...old,
      drawerOpen: true,
      selectedCategory: null,
    }));
  };

  const handleChangeCaseStatusOpen = (row) => {
    console.log("caslcxkasnc");
    setCaseStatusData(row);
    setRecordingListState((old) => ({
      ...old,
      change_case_status_drawer: true,
      select_change_drawer_case: null,
    }));
  };
  const handleChangeCaseStatusClosed = () => {
    setRecordingListState((old) => ({
      ...old,
      change_case_status_drawer: false,
    }));
  };
  let caseAttorneyTitle = "";

  const handleopenChangeAdvisor = (row) => {
    console.log(row, "rowrowrow");
    setCaseStatusData(row);
    setRecordingListState((old) => ({
      ...old,
      change_advisor_status_drawer: true,
      select_change_drawer_advisor: row, // ✅ Set the selected advisor data
    }));
  };
  const handleCloseAdvisorDrawer = () => {
    setRecordingListState((old) => ({
      ...old,
      change_advisor_status_drawer: false,
    }));
    setPageTitle(null); // or setPageTitle(null); depending on your use
  };

  const handleCloseDrawer = () => {
    setRecordingListState((old) => ({ ...old, drawerOpen: false }));
  };
  console.log(newpage, "nsaivguyfvk");

  const [recordingListState, setRecordingListState] = useState(new_valyues);

  const [membersList, setMembersList] = useState([]);
  const [sourceList, setSourceList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState("");
  const [sourceName, setSourcename] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [caseType, setCaseType] = useState(null);

  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [caseStatus, setCaseStatus] = useState(null);
  const [states, setStates] = useState(""); // single state value

  const [filter, setFilter] = useState("");
  const navigate = useNavigate();
  const [sectorFilter, setSectorFilter] = useState(null);
  const [typeFilter, setTypeFilter] = useState(null);

  const [sourceFilter, setSourceFilter] = useState("");
  const [advisor, setAdvisor] = useState(null);

  const [appliedFilters, setAppliedFilters] = useState({
    source: null,
    sector: null,
    type: null,
  });
  const [selectedSourceId, setSelectedSourceId] = useState(null);
  const [tempFilters, setTempFilters] = useState({
    caseType: null,
    occurrencePeriod: null,
    startDate: null,
    endDate: null,
    state: null,
    status: "",
    advisor: null,
    searchText: "",
  });

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOccurancePeriod, setselectedOccurancePeriodId] =
    useState(null);
  const [userList, setUserList] = useState([]);
  const [caseData, setCaseData] = useState([]);

  const handleChangeRowsPerPage = (event) => {
    setIsLoading(true);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  const get_list_of_attorney = async (case_type, stateSend) => {
    const caseParam = case_type !== undefined ? case_type : caseType || "";
    const TypeParam = stateSend !== undefined ? stateSend : states || "";

    try {
      const result = await get_advisor_list_with_filters(
        caseParam,
        TypeParam,
        "created_At",
        "down",
        "", // searchText not defined in current code
        0, // page default
        100 // rowsPerPage default
      );
      console.log(result, "resultresultresult");

      if (result.code === 200) {
        const data = result.advisor.map((item) => ({
          ...item,
          name: item.name || "N/A", // Ensure name is present for Autocomplete
        }));

        setCaseData(data); // ✅ set advisors into dropdown
      } else {
        enqueueSnackbar(result.message || "Failed to fetch advisors", {
          variant: "error",
        });
      }
    } catch (err) {
      enqueueSnackbar("Error fetching advisor list", { variant: "error" });
    } finally {
    }
  };

  const get_user_list = async (
    case_type,
    occurance,
    status,
    stateSend,
    start_date,
    end_date,
    advisorParam,
    searchTextParam // <-- add this
  ) => {
    setIsLoading(true);

    console.log(start_date, end_date, "filters....");

    const caseParam = case_type !== undefined ? case_type : caseType || "";
    const statusparam = status !== undefined ? status : caseStatus || "";

    const TypeParam = stateSend !== undefined ? stateSend : states || "";
    const startDateParam = start_date
      ? moment(start_date).format("YYYY-MM-DD")
      : ""
      ? moment(startDate).format("YYYY-MM-DD")
      : "";

    const endDateParam = end_date
      ? moment(end_date).format("YYYY-MM-DD")
      : ""
      ? moment(endDate).format("YYYY-MM-DD")
      : "";
    const advisorName =
      advisorParam !== undefined ? advisorParam : selectedAdvisor?._id || "";
    console.log(selectedAdvisor, "selectedAdvisorselectedAdvisor");

    console.log(
      caseParam,
      TypeParam,
      searchTextParam !== undefined ? searchTextParam : searchText, // <-- use this
      statusparam,
      startDateParam,
      endDateParam,
      advisorName,
      "filters...."
    );
    console.log(advisorName, "advisorNameadvisorName");

    const result = await get_cases_api(
      caseParam,
      TypeParam,
      searchTextParam !== undefined ? searchTextParam : searchText, // <-- use this
      statusparam,
      startDateParam,
      endDateParam,
      advisorName,
      page,
      rowsPerPage
    );
    if (result.code === 200) {
      let data = result.case.map((item) => {
        let created_At = "N/A";
        let case_type = "N/A";
        let occurrencePeriod = "N/A";
        let status = "N/A";
        let state = "N/A";
        let advisor = "N/A";
        let caseDetails = "N/A";
        let user_name = "N/A";
        console.log(item, "itemitemitemitemitem");
        if (item?.user_id?.name) {
          user_name = item?.user_id?.name;
        }

        if (item.createdAt) {
          created_At = moment(item.createdAt).format("DD-MM-YYYY");
        }
        if (item.advisor_id?.name) {
          advisor = item.advisor_id?.name;
        }
        if (item.case_type) {
          case_type = item?.case_type;
        }

        if (item.occurrencePeriod) {
          occurrencePeriod = item?.occurrencePeriod;
        }
        if (item.status) {
          status = item?.status;
        }
        if (item.state) {
          state = item?.state;
        }
        if (item.caseDetails) {
          caseDetails = item?.caseDetails;
        }

        return {
          ...item,
          created_At,
          case_type,
          occurrencePeriod,
          status,
          state,
          caseDetails,
          advisor,

          user_name,
          MENU_OPTIONS: handleMenu(item),
        };
      });
      setUserList(data);
      setTotalCount(result.total_count);
      setTotalPages(result.total_pages);
      setIsLoading(false);
    } else {
      // enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };
  function download_csv_file(headers, data) {
    const headerRow = headers.map((column) => column.label);
    const csvRows = [headerRow];

    data.forEach((row) => {
      const dataRow = headers.map((column) => row[column.key] || "");
      csvRows.push(dataRow);
    });

    const csvContent = csvRows.map((row) => row.join(",")).join("\n");

    const hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csvContent);
    hiddenElement.target = "_blank";
    hiddenElement.download = "transactions.csv";
    hiddenElement.click();
  }
  const handleExportCsv = async () => {
    setIsLoading(true);
    try {
      const caseParam = caseType || "";
      const statusparam = caseStatus || "";
      const TypeParam = states || "";
      const startDateParam = startDate
        ? moment(startDate).format("YYYY-MM-DD")
        : "";
      const endDateParam = endDate ? moment(endDate).format("YYYY-MM-DD") : "";

      const result = await get_cases_api(
        caseParam,
        selectedOccurancePeriod || "",
        TypeParam,
        searchText,
        statusparam,
        startDateParam,
        endDateParam,
        selectedAdvisor?._id || "",
        0,
        600
      );

      if (result.code === 200 && result.case?.length) {
        console.log(result.case[0].user_id, "USER ID FIELDS CHECK");

        console.log(result, "suacuisacresultresultresult");
        const exportData = result.case.map((item) => ({
          ...item,
          case_type: item.case_type || "N/A",
          attorneys: item?.attorneys || "N/A",
          state: item?.state || "N/A",
          advisor: item?.advisor_id?.name || "N/A",
          occurrencePeriod: show_proper_words(item?.occurrencePeriod || "N/A"),
          caseDetails: item?.caseDetails || "N/A",
          createdAt: item?.createdAt
            ? moment(item.createdAt).format("DD-MM-YYYY")
            : "N/A",
          name: item?.user_id?.name || "N/A",
          email: item?.user_id?.email || "N/A",
          phone: item?.user_id?.phone || "N/A",
        }));

        download_csv_file(headers, exportData);
      } else {
        enqueueSnackbar("No data found to export", { variant: "info" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong while exporting", {
        variant: "error",
      });
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(0);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
    get_user_list();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(0);
    } else {
      setPageCount(newPage + 1);
    }
    get_user_list();
  };
  const headers = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Phone Number", key: "phone" },
    { label: "Case Type", key: "case_type" },
    { label: "Attorney", key: "advisor" },
    { label: "State", key: "state" },
    { label: "Occurrence Period", key: "occurrencePeriod" },
    { label: "Case Details", key: "caseDetails" },
    { label: "Added At", key: "createdAt" },
  ];

  const TABLE_HEAD = [
    {
      id: "action",
      label: "Action",
      type: "action",
      MENU_OPTIONS: "MENU_OPTIONS",
    },
    { id: "number", label: "#", type: "number" },
    { id: "user_name", label: "User Name" },
    { id: "state", label: "State" },
    { id: "advisor", label: "Attorney" },
    // { id: "case_type", label: "Case Type" },
    {
      id: "case_type",
      label: "Case Type",
      renderData: (row) => {
        return <span>{show_proper_words(row?.case_type)}</span>;
      },
    },
    {
      id: "occurrencePeriod",
      label: "Occurrence Period",
      renderData: (row) => {
        return <span>{show_proper_words(row?.occurrencePeriod)}</span>;
      },
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => {
        const status = row?.status;
        let backgroundColor = "";
        let textColor = "white";

        if (status === "failed") {
          backgroundColor = "#f44336";
        } else if (status === "pending") {
          backgroundColor = "#FF9800";
        } else if (status === "recovered") {
          backgroundColor = "#4CAF50";
          textColor = "#fff";
        } else if (status === "assigned") {
          backgroundColor = "#6e4b45";
          textColor = "#fff";
        }
        const getStatusLabel = (status) => {
          if (status === "pending") return "Pending";
          if (status === "recovered") return "Recovered";
          if (status === "failed") return "Failed";
          if (status === "assigned") return "Assigned";
          return status;
        };

        return (
          <span
            style={{
              backgroundColor,
              color: textColor,
              padding: "4px 8px",
              borderRadius: "12px",
              fontSize: "12px",
              display: "inline-block",
              minWidth: "60px",
              textAlign: "center",
            }}
          >
            {getStatusLabel(status)}
          </span>
        );
      },
    },
  ];
  function capitalizeWords(string) {
    return string
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  function fullWord(str) {
    if (!str) return "";
    const replacements = {
      clients: "Client",
      industry_suppliers: "Industry Supplier",
    };

    const lowerStr = str.toLowerCase();

    if (replacements[lowerStr]) {
      return replacements[lowerStr];
    }

    return str
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  const searchFunction = (e) => {
    e.preventDefault();
    setPage(0);
    setPageCount(1);
    get_user_list(
      tempFilters.caseType || "",
      tempFilters.occurrencePeriod || "",
      tempFilters.status || "",
      tempFilters.state || "",
      tempFilters.startDate || "",
      tempFilters.endDate || "",
      tempFilters.advisor || "",
      searchText // <-- pass searchText
    );
  };

  useEffect(() => {
    get_user_list();
  }, [page, rowsPerPage]);
  useEffect(() => {
    get_list_of_attorney();
  }, []);

  const handleDeleteMember = async (memberId) => {
    console.log(memberId, "memberIdmemberIdmemberId");
    setDeleteLoading(true);
    const response = await delete_Case_api(memberId);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setDeleteDialogOpen(false);
      get_user_list();
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setDeleteDialogOpen(false);
    }
    setDeleteLoading(false);
  };

  const handleDelete = (row) => {
    console.log(row, "rowrowrow");
    setDeletingMemberId(row._id);
    setDeleteDialogOpen(true);
  };

  const handleClickEdit = (row) => {
    navigate(`/list-cases/update/${row._id}`);
  };
  const handleClickDetail = (row) => {
    navigate(`/list-cases/detail/${row._id}`);
  };
  console.log(advisor, "advisoradvisor");
  const applyFilters = () => {
    setTempFilters({
      caseType: caseType,
      occurrencePeriod: selectedOccurancePeriod,
      state: states,
      status: caseStatus,
      startDate: startDate,
      endDate: endDate,
      advisor: advisor,
    });
    setPage(0);
    setPageCount(1);
    handleCloseDrawer();
    // get_user_list();
  };

  const clearFilters = () => {
    setCaseType("");
    setselectedOccurancePeriodId("");
    setStartDate(null);
    setEndDate(null);
    setStates("");
    setCaseStatus("");
    setSearchText("");
    setAdvisor(null);
    setSelectedAdvisor(null);
    setTempFilters((prev) => ({ ...prev, state: null }));
    setTempFilters((prev) => ({ ...prev, occurrencePeriod: null }));
    setTempFilters((prev) => ({ ...prev, caseType: null }));
    setTempFilters((prev) => ({ ...prev, caseoccurrencePeriodType: null }));
    setTempFilters((prev) => ({ ...prev, startDate: null }));
    setTempFilters((prev) => ({ ...prev, endDate: null }));
    setTempFilters((prev) => ({ ...prev, advisor: null }));
    setPage(0);
    setPageCount(1);
    get_user_list("", "", "", "", "", "", "");
    handleCloseDrawer();
  };
  console.log(
    tempFilters,
    "tempFilterstempFiltetempFilterstempFiltersrstempFilters"
  );
  const handleMenu = (row) => {
    const MENU_OPTIONS = [
      {
        label: "Edit",
        icon: "mdi:pencil-outline",
        handleClick: () => handleClickEdit(row),
      },
      {
        label: "Delete",
        icon: "mdi:delete-outline",
        handleClick: () => handleDelete(row),
      },
      {
        label: "Case Details",
        icon: "bxs:detail",
        handleClick: () => handleClickDetail(row),
      },

      row.status === "pending"
        ? {
            label: "Assign Attorney",
            icon: "fluent:status-12-filled",
            handleClick: () => handleopenChangeAdvisor(row),
          }
        : {
            label: "Change Attorney",
            icon: "simple-icons:homeadvisor",
            handleClick: () => handleopenChangeAdvisor(row),
          },
      {
        label: "Change Case Status",
        icon: "simple-icons:homeadvisor",
        handleClick: () => handleChangeCaseStatusOpen(row),
      },
    ];

    return MENU_OPTIONS;
  };

  const handleAdvisorChange = (advisor) => {
    setSelectedAdvisor(advisor); // UI ke liye local state
    setTempFilters((prev) => ({
      ...prev,
      advisor: advisor?.name || "", // yahan name ya jis field pe filter ho raha ho
    }));
  };

  const getActiveFilterCount = () => {
    let count = 0;
    if (selectedSourceId) count++;
    if (sectorFilter) count++;
    if (typeFilter) count++;
    return count;
  };
  useEffect(() => {
    get_user_list(
      tempFilters.caseType || "",
      tempFilters.occurrencePeriod || "",
      tempFilters.status || "",
      tempFilters.state || "",
      tempFilters.startDate || "",
      tempFilters.endDate || "",
      tempFilters.advisor || "",
      searchText // <-- pass searchText
    );
  }, [tempFilters]);

  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="d-flex justify-content-between flex-wrap align-items-center mb-4 members_heading">
          <div>
            <h3>Cases</h3>
          </div>
          <div className="text-end">
            <Button
              variant="contained"
              className="me-1"
              onClick={handleExportCsv}
            >
              <DownloadIcon sx={{ mr: 1 }} />
              Export CSV
            </Button>
            <Button
              variant="contained"
              startIcon={<FilterListIcon />}
              onClick={handleopenFilterDrawer}
            >
              Filters
            </Button>
          </div>
        </div>
        {(tempFilters.caseType ||
          tempFilters.occurrencePeriod ||
          tempFilters.startDate ||
          tempFilters.endDate ||
          tempFilters.state ||
          tempFilters.status ||
          tempFilters.advisor) && (
          <div className="mb-3 d-flex flex-wrap align-items-center gap-2">
            {tempFilters.caseType && (
              <div className="filter-chip">
                Case Type: {show_proper_words(tempFilters.caseType)}
                <span
                  className="chip-close"
                  onClick={async () => {
                    await setCaseType(null);
                    await setTempFilters((prev) => ({
                      ...prev,
                      caseType: null,
                    }));
                    get_user_list(
                      "",
                      tempFilters.occurrencePeriod || "",
                      tempFilters.status || "",
                      tempFilters.state || "",
                      tempFilters.startDate || "",
                      tempFilters.endDate || ""
                    );
                  }}
                >
                  ×
                </span>
              </div>
            )}

            {/* {tempFilters.occurrencePeriod && (
              <div className="filter-chip">
                Occurrence Period:{" "}
                {show_proper_words(tempFilters.occurrencePeriod)}
                <span
                  className="chip-close"
                  onClick={async () => {
                    await setselectedOccurancePeriodId(null);
                    await setStartDate(null);
                    await setEndDate(null);
                    await setTempFilters((prev) => ({
                      ...prev,
                      occurrencePeriod: null,
                      startDate: null,
                      endDate: null,
                    }));
                    get_user_list(
                      tempFilters.caseType || "",
                      "",
                      tempFilters.status || "",
                      tempFilters.state || "",
                      // tempFilters.startDate || "",
                      // tempFilters.endDate || ""
                      "",
                      ""
                    );
                  }}
                >
                  ×
                </span>
              </div>
            )} */}

            {tempFilters.status && (
              <div className="filter-chip">
                Status:{" "}
                {tempFilters.status === "pending"
                  ? "Pending"
                  : tempFilters.status === "recovered"
                  ? "Recovered"
                  : tempFilters.status === "assigned"
                  ? "Assigned"
                  : "Failed"}
                <span
                  className="chip-close"
                  onClick={() => {
                    setCaseStatus(null);
                    setTempFilters((prev) => ({ ...prev, status: null }));
                    get_user_list(
                      tempFilters.caseType || "",
                      tempFilters.occurrencePeriod || "",
                      "",
                      tempFilters.state || "",
                      tempFilters.startDate || "",
                      tempFilters.endDate || ""
                    );
                  }}
                >
                  ×
                </span>
              </div>
            )}

            {tempFilters.startDate && (
              <div className="filter-chip">
                Start Date: {moment(tempFilters.startDate).format("YYYY-MM-DD")}
                <span
                  className="chip-close"
                  onClick={async () => {
                    await setStartDate(null);
                    await setEndDate(null);
                    await setselectedOccurancePeriodId(null);
                    setTempFilters((prev) => ({
                      ...prev,
                      startDate: null,
                      endDate: null,
                      occurrencePeriod: null,
                    }));
                    get_user_list(
                      tempFilters.caseType || "",
                      "",
                      tempFilters.status || "",
                      tempFilters.state || "",
                      "",
                      ""
                    );
                  }}
                >
                  ×
                </span>
              </div>
            )}

            {tempFilters.endDate && (
              <div className="filter-chip">
                End Date: {moment(tempFilters.endDate).format("YYYY-MM-DD")}
                <span
                  className="chip-close"
                  onClick={async () => {
                    await setEndDate(null);
                    await setStartDate(null);
                    await setselectedOccurancePeriodId(null);
                    setTempFilters((prev) => ({
                      ...prev,
                      endDate: null,
                      startDate: null,
                      occurrencePeriod: null,
                    }));
                    get_user_list(
                      tempFilters.caseType || "",
                      "",
                      tempFilters.status || "",
                      tempFilters.state || "",
                      "",
                      ""
                    );
                  }}
                >
                  ×
                </span>
              </div>
            )}

            {tempFilters.state && (
              <div className="filter-chip">
                State: {tempFilters.state}
                <span
                  className="chip-close"
                  onClick={() => {
                    setStates(null);
                    setTempFilters((prev) => ({ ...prev, state: null }));
                    get_user_list(
                      tempFilters.caseType || "",
                      tempFilters.occurrencePeriod || "",
                      tempFilters.startDate || "",
                      tempFilters.endDate || "",
                      "",
                      tempFilters.status || ""
                    );
                  }}
                >
                  ×
                </span>
              </div>
            )}
            {tempFilters.advisor && (
              <div className="filter-chip">
                Attorney: {selectedAdvisor?.name}
                <span
                  className="chip-close"
                  onClick={() => {
                    setAdvisor(null);
                    setSelectedAdvisor(null);
                    setTempFilters((prev) => ({ ...prev, advisor: null }));
                    get_user_list(
                      tempFilters.caseType || "",
                      tempFilters.occurrencePeriod || "",
                      tempFilters.status || "",
                      tempFilters.state || "",
                      tempFilters.startDate || "",
                      tempFilters.endDate || "",
                      "" // advisor reset
                    );
                  }}
                >
                  ×
                </span>
              </div>
            )}

            <button
              className="btn  btn-sm filter-chip-clear-all"
              onClick={() => {
                setCaseType(null);
                setselectedOccurancePeriodId(null);
                setCaseStatus(null);
                setStartDate(null);
                setEndDate(null);
                setStates(null);
                setAdvisor(null);
                setSelectedAdvisor(null);
                setTempFilters({
                  caseType: null,
                  occurrencePeriod: null,
                  startDate: null,
                  endDate: null,
                  state: null,
                  status: null,
                  advisor: null,
                });
                get_user_list("", "", "", "", "", "");
              }}
            >
              Clear All <span className="chip-close clear-all ">✕</span>
            </button>
          </div>
        )}

        <div className="p-0">
          <CustomMUITable
            TABLE_HEAD={TABLE_HEAD}
            data={userList}
            pagePagination={true}
            // MENU_OPTIONS={MENU_OPTIONS}
            custom_pagination={{
              total_count: totalCount,
              rows_per_page: rowsPerPage,
              page: page,
              handleChangePage: handleChangePage,
              onRowsPerPageChange: handleChangeRowsPerPage,
            }}
            custom_search={{
              searchText: searchText,
              setSearchText: setSearchText,
              handleSubmit: searchFunction,
            }}
            pageCount={pageCount}
            totalPages={totalPages}
            handleChangePages={handleChangePages}
          />
        </div>
      </div>

      <CustomDrawer
        isOpenDrawer={recordingListState.change_case_status_drawer} // <-- FIXED THIS
        onCloseDrawer={handleChangeCaseStatusClosed}
        pageTitle={`${
          recordingListState.select_change_drawer_case
            ? "Change Case Status"
            : "Change Case Status"
        } `}
        componentToPassDown={
          <ChangeCaseStatus
            onCloseDrawer={handleChangeCaseStatusClosed} // <-- Possibly should be this instead of handleCloseAdvisorDrawer
            selectedObject={recordingListState.select_change_drawer_case}
            userList={userList}
            memberId={deletingMemberId}
            caseSStatusDATA={caseSStatusDATA}
            get_user_list={get_user_list}
          />
        }
      />
      {console.log(recordingListState, "recordingListState")}
      <CustomDrawer
        isOpenDrawer={recordingListState.change_advisor_status_drawer}
        onCloseDrawer={handleCloseAdvisorDrawer}
        pageTitle={
          recordingListState.select_change_drawer_advisor?.status === "pending"
            ? "Assign Attorney"
            : "Change Attorney"
        }
        componentToPassDown={
          <ChangeCaseAdvisor
            onCloseDrawer={handleCloseAdvisorDrawer}
            selectedObject={recordingListState.select_change_drawer_advisor}
            caseSStatusDATA={caseSStatusDATA}
            get_user_list={get_user_list}
          />
        }
      />

      <CustomDrawer
        isOpenDrawer={recordingListState.drawerOpen}
        // onOpenDrawer={handleCloseDrawer}
        onCloseDrawer={handleCloseDrawer}
        pageTitle={`${
          recordingListState.selectedCategory ? "Filters" : "Filters"
        } `}
        componentToPassDown={
          <FilterDRawerCases
            onCloseDrawer={handleCloseDrawer}
            selectedObject={recordingListState.selectedCategory}
            refreshList={get_user_list}
            memberList={membersList}
            setSourceFilter={setSourceFilter}
            setSourceList={setSourceList}
            sourceList={sourceList}
            selectedSourceId={selectedSourceId}
            setSelectedSourceId={setSelectedSourceId}
            setOage={setPage}
            setPageCount={setPageCount}
            applyFilters={applyFilters}
            caseType={caseType}
            setCaseType={setCaseType}
            selectedOccurancePeriod={selectedOccurancePeriod}
            setselectedOccurancePeriodId={setselectedOccurancePeriodId}
            endDate={endDate}
            setEndDate={setEndDate}
            startDate={startDate}
            setStartDate={setStartDate}
            setStates={setStates}
            states={states}
            clearFilters={clearFilters}
            caseStatus={caseStatus}
            setCaseStatus={setCaseStatus}
            tempFilters={tempFilters}
            setTempFilters={setTempFilters}
            caseSStatusDATA={caseSStatusDATA}
            setSelectedAdvisor={setSelectedAdvisor}
            selectedAdvisor={selectedAdvisor}
            caseData={caseData}
            setCaseData={setCaseData}
            handleAdvisorChange={handleAdvisorChange}
            setAdvisor={setAdvisor}
            advisor={advisor}
          />
        }
      />

      <CustomConfirmation
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        title={"Are you sure you want to delete this Case?"}
        handleAgree={() => handleDeleteMember(deletingMemberId)}
      />
    </div>
  );
};

export default Cases;
